module.exports = __webpack_public_path__ + "img/im_pizza.bcedb3f0.png";